import request from '@/config/request'

export default {

  searchLastHealthReport: function (customerCode, type) {
    return request({
      url: '/health/healthreport/searchlasthealthreport',
      method: 'get',
      params: {
        customercode: customerCode,
        type: type,
      }
    })
  },

  searchHealthReportForHealthScreen: function (reportCode) {
    return request({
      url: '/health/healthreport/searchhealthreportforhealthscreen',
      method: 'get',
      params: {
        reportcode: reportCode,
      }
    })
  },

  searchHealthReportForEating: function (reportCode) {
    return request({
      url: '/health/healthreport/searchhealthreportforeating',
      method: 'get',
      params: {
        reportcode: reportCode,
      }
    })
  },

  searchHealthReportForDiet: function (reportCode) {
    return request({
      url: '/health/healthreport/searchhealthreportfordiet',
      method: 'get',
      params: {
        reportcode: reportCode,
      }
    })
  },

  searchHealthReportForAnxiety: function (reportCode) {
    return request({
      url: '/health/healthreport/searchhealthreportforanxiety',
      method: 'get',
      params: {
        reportcode: reportCode,
      }
    })
  },

  insertHealthReport: function (report, reportDetail) {
    return request({
      url: '/health/healthreport/inserthealthreport',
      method: 'post',
      data: {
        report: report,
        reportdetail: reportDetail,
      }
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/health/healthreport.js